import type { ValidationErrors } from '../../../../../utils/validation';
import type { ICustomControlData } from './customControlData';
import { Gender } from '../../../../../../common/enums/gender';
import { translateKey } from '../../../../../translate';
import { useEpisodeContext } from '../../../../../utils/hooks/useEpisodeContext';
import { FormParagraph } from '../../../../elements/common';
import { RadioGroupField } from '../../../../fields/RadioGroup';

interface IGeslachtAddEditProps {
    customControlData: ICustomControlData;
    errors: ValidationErrors;
    handleChangeCustomControl: (customControl: Partial<ICustomControlData>) => Promise<void>;
}

export function GeslachtAddEdit(props: IGeslachtAddEditProps) {
    const { patient } = useEpisodeContext();

    if (patient.gender === Gender.male || patient.gender === Gender.female) {
        return null;
    }

    return (
        <>
            <FormParagraph>
                Het geslacht van de patiënt is '{translateKey(`genderEnum.${patient.gender!}`)}'. De holter accepteert
                alleen man of vrouw als geslacht. Maak een keuze?
            </FormParagraph>
            <RadioGroupField
                automation="geslachtHolter"
                error={props.errors.get('customControlData.geslachtHolter')}
                fieldKey="geslachtHolter"
                hasErrors={props.errors.has('customControlData.geslachtHolter')}
                isRequired
                label="Geslacht"
                onChange={async (value) =>
                    await props.handleChangeCustomControl({ geslachtHolter: translationToHolterGender(value) })
                }
                options={[holterGenderToTranslation(Gender.male), holterGenderToTranslation(Gender.female)]}
                value={
                    props.customControlData.geslachtHolter
                        ? holterGenderToTranslation(props.customControlData.geslachtHolter)
                        : null
                }
            />
        </>
    );
}

function translationToHolterGender(value: string) {
    return value === holterGenderToTranslation(Gender.male) ? Gender.male : Gender.female;
}

function holterGenderToTranslation(value: Gender | null) {
    return value === Gender.male ? translateKey('genderEnum.male') : translateKey('genderEnum.female');
}
